import React, { useState } from 'react';
import { Modal, Form, InputNumber, DatePicker, Select, Input, Button } from 'antd';

interface PaymentModalProps {
  visible: boolean;
  onCancel: () => void;
  onSubmit: (values: any) => void;
}

const PaymentModal: React.FC<PaymentModalProps> = ({ visible, onCancel, onSubmit }) => {
  const [form] = Form.useForm();
  const [paymentMethod, setPaymentMethod] = useState<string | undefined>();

  const handlePaymentMethodChange = (value: string) => {
    setPaymentMethod(value);
  };

  const handleFinish = (values: any) => {
    onSubmit(values);
    form.resetFields();
    setPaymentMethod(undefined);
  };

  return (
    <Modal
      title="Make a Payment"
      visible={visible}
      onCancel={() => {
        form.resetFields();
        setPaymentMethod(undefined);
        onCancel();
      }}
      footer={null}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleFinish} autoComplete="off">
        <Form.Item
          label="Payment Amount"
          name="sp_payment_amount"
          rules={[{ required: true, message: 'Please enter payment amount' }]}
        >
          <InputNumber
            min={0}
            formatter={value => `₹ ${value}`}
            style={{ width: '100%' }}
            onBeforeInput={(e: React.FormEvent<HTMLInputElement>) => {
              const nativeEvent = e.nativeEvent as InputEvent;
              const inputChar = nativeEvent.data;
              const currentValue = (e.target as HTMLInputElement).value;

              if (!inputChar || !/^\d$/.test(inputChar) || currentValue.length >= 12) {
                e.preventDefault();
              }
            }}
          />
        </Form.Item>
        <Form.Item
          label="Payment Date"
          name="sp_payment_date"
          rules={[{ required: true, message: 'Please select payment date' }]}
        >
          <DatePicker style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item
          label="Payment Method"
          name="sp_payment_method"
          rules={[{ required: true, message: 'Please select a payment method' }]}
        >
          <Select placeholder="Select payment method" allowClear onChange={handlePaymentMethodChange}>
            <Select.Option value="Razorpay">Razorpay</Select.Option>
            <Select.Option value="Cash">Cash</Select.Option>
            <Select.Option value="Credit Card">Credit Card</Select.Option>
            <Select.Option value="Bank Transfer">Bank Transfer</Select.Option>
          </Select>
        </Form.Item>
        {paymentMethod === 'Razorpay' && (
          <>
            <Form.Item
              label="Razorpay Payment ID"
              name="sp_razorpay_payment_id"
              rules={[{ required: true, message: 'Please enter Razorpay payment ID' }]}
            >
              <Input placeholder="Enter Razorpay Payment ID" />
            </Form.Item>
            <Form.Item
              label="Razorpay Order ID"
              name="sp_razorpay_order_id"
              rules={[{ required: true, message: 'Please enter Razorpay order ID' }]}
            >
              <Input placeholder="Enter Razorpay Order ID" />
            </Form.Item>
            <Form.Item
              label="Razorpay Signature"
              name="sp_razorpay_signature"
              rules={[{ required: true, message: 'Please enter Razorpay signature' }]}
            >
              <Input placeholder="Enter Razorpay Signature" />
            </Form.Item>
          </>
        )}
        {paymentMethod === 'Cash' && (
          <>
            <Form.Item
              label="Cash Received By"
              name="sp_cash_received_by"
              rules={[{ required: true, message: 'Please enter who received cash' }]}
            >
              <Input placeholder="Enter receiver's name" />
            </Form.Item>
            <Form.Item
              label="Cash Receipt Number"
              name="sp_cash_receipt_number"
              rules={[{ required: true, message: 'Please enter cash receipt number' }]}
            >
              <Input placeholder="Enter receipt number" />
            </Form.Item>
          </>
        )}
        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            Submit Payment
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PaymentModal;
